import { type AuthUser } from "wasp/auth";
import Breadcrumb from "../../layout/Breadcrumb";
import DefaultLayout from "../../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../../useRedirectHomeUnlessUserIsAdmin";
import FlaggedArticlesTable from "./FlaggedArticlesTable";

export const FlaggedArticlesDashboardPage = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });

  return (
    <DefaultLayout user={user}>
      <Breadcrumb pageName="Flagged Articles" />
      <div className="flex flex-col gap-10">
        <FlaggedArticlesTable />
      </div>
    </DefaultLayout>
  );
};
